import React from "react";

/**
 * SyncStatusIndicator - Shows when a Plaid account is syncing
 *
 * @param {boolean} syncing - Whether sync is in progress
 * @param {string} status - Current sync status message
 * @param {string} className - Additional CSS classes
 */
const SyncStatusIndicator = ({ syncing, status, className = "" }) => {
  if (!syncing) return null;

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-sm ${className}`}
    >
      {/* Spinner */}
      <svg
        className="animate-spin h-4 w-4 text-blue-600 dark:text-blue-400"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>

      {/* Status message */}
      <span className="text-blue-700 dark:text-blue-300 font-medium">
        {status || "Syncing..."}
      </span>
    </div>
  );
};

export default SyncStatusIndicator;
